import {Component, inject, OnInit} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HeaderComponent} from "../../../common/header/header.component";
import {NgOptimizedImage} from "@angular/common";
import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";
import {ContactInformation} from "../../../../interfaces/contact-information";
import {TextInputComponent} from "../../../common/text-input/text-input.component";
import {ValidationService} from "../../../../services/validation.service";

@Component({
  selector: 'app-witness-information',
  imports: [
    FooterComponent,
    FormsModule,
    HeaderComponent,
    ReactiveFormsModule,
    NgOptimizedImage,
    TextInputComponent
  ],
  templateUrl: './witness-information.component.html',
  styleUrl: './witness-information.component.css'
})
export class WitnessInformationComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);
  private validationService = inject(ValidationService);

  showError: boolean = false;
  showMandatoryFieldError: boolean = false;
  options: { headline: string, caption: string, value: boolean }[] = [];
  radioControl = new FormControl();
  witnesses: ContactInformation[] = [];
  witnessErrors: { surname: boolean; name: boolean; phone: boolean; email: boolean }[] = []

  ngOnInit(): void {
    this.options = [
      {
        headline: this.locale.currentTranslation.yes,
        caption: '',
        value: true
      },
      {
        headline: this.locale.currentTranslation.no,
        caption: '',
        value: false
      }
    ]
    this.addWitness();
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.witnessesAreKnown !== null) {
        this.radioControl = new FormControl(this.claimService.claimReport().witnessesAreKnown);
      }
      if (this.claimService.claimReport()?.witnesses) {
        this.witnesses = this.claimService?.claimReport()?.witnesses
      }
    })
  }

  nextClicked() {
    this.evaluateShowError()
    if (!this.showError && !this.showMandatoryFieldError) {
      this.claimService.updateClaimReport({
        witnessesAreKnown: this.radioControl.getRawValue(),
        witnesses: this.witnesses
      });
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['witness-information']);
      });
    }
  }

  private evaluateShowError() {
    let rawValue = this.radioControl.getRawValue();
    this.showError = rawValue === null;
    let allMandatoryFieldsSet = true;

    this.witnesses.forEach((witness, index) => {
      if (index >= this.witnessErrors.length) {
        this.witnessErrors.push({ surname: false, name: false, phone: false, email: false });
      }

      this.witnessErrors[index].surname = this.validationService.isEmptyOrWhitespace(witness.surname);
      this.witnessErrors[index].name = this.validationService.isEmptyOrWhitespace(witness.name);
      this.witnessErrors[index].phone = !this.validationService.isValidPhoneNumber(witness.phone);
      this.witnessErrors[index].email = !this.validationService.isValidEmail(witness.email);

      if (this.witnessErrors[index].surname || this.witnessErrors[index].name || this.witnessErrors[index].phone || this.witnessErrors[index].email) {
        allMandatoryFieldsSet = false;
      }
    });

    this.showMandatoryFieldError = rawValue && !allMandatoryFieldsSet;
  }

  setOption(value: boolean) {
    this.radioControl.patchValue(value);
    this.showError = false;
  }

  addWitness() {
    this.witnesses.push({
      surname: null,
      name: null,
      phone: null,
      email: null
    });
    this.witnessErrors.push({
      surname: false,
      name: false,
      phone: false,
      email: false
    });
  }

  removeWitness(item: ContactInformation) {
    const index = this.witnesses.indexOf(item);
    this.witnesses.splice(index, 1);
    this.witnessErrors.splice(index, 1);
  }
}
